var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.434,
    height: 23.508,
    viewBox: "0 0 22.434 23.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "foil",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_129",
    "data-name": "Trac\\xE9 129",
    d: "M15.556,14.1h0c-3.448.167-6.107,1.545-6.315,3.257H9.2V34.393c.166,1.712,3.365,3.215,6.979,3.215a9.81,9.81,0,0,0,6.232-1.879h9.223V14.1Zm6.4,20.168a.452.452,0,0,1-.125.292,1.941,1.941,0,0,1-.582.585,8.91,8.91,0,0,1-1.08.585,9.937,9.937,0,0,1-3.988.71c-3.49,0-5.691-1.42-5.733-2.171V19.57a9.843,9.843,0,0,0,5.11,1.461H16.8a9.468,9.468,0,0,0,5.11-1.461l.042,14.7Zm-.125-16.327a2.194,2.194,0,0,1-.5.585,8.257,8.257,0,0,1-4.57,1.336H15.515a8.357,8.357,0,0,1-4.57-1.336,3.362,3.362,0,0,1-.5-.585.676.676,0,0,1-.125-.376.378.378,0,0,1,.042-.209c.249-.96,2.243-1.963,5.068-2.088h1.246c2.825.125,4.819,1.127,5.068,2.088,0,.084.042.125.042.209C21.912,17.691,21.871,17.816,21.829,17.942ZM30.387,34.56h-7.27v-17.2h-.042a3.029,3.029,0,0,0-1.7-2.13h8.973V34.56Z",
    transform: "translate(-9.2 -14.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_130",
    "data-name": "Trac\\xE9 130",
    d: "M24.648,20.478a.676.676,0,0,1-.125.376,1.318,1.318,0,0,1-.665.585,5.655,5.655,0,0,1-1.662.376c-.208,0-.415.042-.623.042a3.129,3.129,0,0,1-.623-.042,5.968,5.968,0,0,1-1.662-.376,1.318,1.318,0,0,1-.665-.585.676.676,0,0,1-.125-.376.378.378,0,0,1,.042-.209c.166-.71,1.246-1.044,2.368-1.127a4.671,4.671,0,0,1,1.246,0c1.122.084,2.2.418,2.368,1.127C24.648,20.311,24.648,20.394,24.648,20.478Z",
    transform: "translate(-14.636 -17.012)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoil);
export default __webpack_public_path__ + "static/media/foil.362091c84c23d1fe560a619f2b7accb8.svg";
export { ForwardRef as ReactComponent };